import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-modal-logos-empresas",
  templateUrl: "./modal-logos-empresas.page.html",
  styleUrls: ["./modal-logos-empresas.page.scss"],
})
export class ModalLogosEmpresasPage implements OnInit {
  @Input() empresas: any[];

  constructor(public modalCtrl: ModalController) {}

  ngOnInit(): void {}

  selectEmpresa(nome_fantasia) {
    this.modalCtrl.dismiss(nome_fantasia);
  }
}
